/* resend email confirmation */
;
(function () {

    const $btn = $('.js-m-resend-confirmation');
    if (!$btn.length) return false;

    $btn.on('click', (e) => {
        e.preventDefault();

        $.ajax({
            method: 'POST',
            dataType: 'json',
            url: '/ajax/resendemail',
            success: function (response) {
                if (response.status) {
                    console.log(response.status);
                    $.snackbar('Confirmation email was sent');
                } else if (response.time) {
                    console.log(response.time);
                    $.snackbar('Email was already sent! You can send the next email in ' + response.time);
                } else {
                    $.snackbar('Error! Email wasn\'t sent');
                }
            }
        });
    })

})();